import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/globalConfig',
        name: 'globalConfig',
        meta: { sideMenuLabel: "Configurazione globale" },
        component: () => import("./views/globalConfig.vue")
    }
];

export default routes;